import { Flex, Text } from "@chakra-ui/react";

/**
 * News item interface
 * @see src/components/news/index.tsx
 */
interface NewsItem {
  title: string;
  slug?: string;
  source?: string;
  author?: string;
  publishedDate?: string;
  [key: string]: any; // For other properties that might exist
}

/**
 * Props interface for AuthorInfo component
 * @see src/components/news/AuthorInfo.tsx
 */
interface AuthorInfoProps {
  /** News item to display author information for */
  oneNews: NewsItem;
}

/**
 * Component for displaying author information for a news article
 * @see src/components/news/AuthorInfo.tsx
 */
const AuthorInfo = ({ oneNews }: AuthorInfoProps) => {
  return (
    <Flex
      flexDir={"column"}
      rowGap={"12.27px"}
      mt={{ base: "36px", smd: "47px" }}
      mb={{ base: "25px" }}
    >
      <Text
        fontSize={"24px"}
        fontWeight={"700"}
        lineHeight={"normal"}
        letterSpacing={"0.48px"}
      >
        From {oneNews?.source}
      </Text>
      <Text
        fontSize={"21px"}
        fontWeight={"400"}
        lineHeight={"normal"}
        letterSpacing={"0.42px"}
      >
        By {oneNews?.author}
      </Text>
      <Text
        fontSize={"16px"}
        fontWeight={"700"}
        lineHeight={"1"}
        letterSpacing={"0.32px"}
        color={"grey"}
      >
        {oneNews?.publishedDate 
          ? new Date(oneNews.publishedDate).toLocaleDateString("en-eu", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })
          : ""}
      </Text>
    </Flex>
  );
};

export default AuthorInfo;
